import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI, AutoCompleteSelectUI } from '../Interface';

const WorkAreaFields = ({ viewField, autocompleteOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4">
        <Field
          type="text"
          name="code"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Kód" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.code} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.code && values.code !== '' }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>

      <div className="md:col-span-2 col-span-4">
        <Field
          type="autocomplete"
          name="groupId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Csoport" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.groupId} />}
          onChange={(_e, newVal) => {
            setFieldValue('groupId', newVal?.value ?? null).then(() => {
              validateField('groupId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.groupId !== '' }}
          selectedValue={values.groupId}
          selectedLabelValue={autocompleteOptions?.group.find((item) => item.value === values.groupId)?.label || ''}
          dataset={autocompleteOptions?.group}
        />
      </div>
    </div>
  );
};

export default WorkAreaFields;
